module.exports = __webpack_public_path__ + "images/help/icon-twr42@2x-f18215542ce42096e8b455b5277a9372.png";